import { toast } from "react-toastify";
import { captureReceiptCanvas } from "./captureReceiptCanvas";

export const shareReceiptAsImage = async (
  el: HTMLDivElement,
  reference: string | undefined,
  filePrefix = "transaction"
): Promise<void> => {
  try {
    const canvas = await captureReceiptCanvas(el);

    canvas.toBlob(blob => {
      if (!blob) return;
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `${filePrefix}-${reference ?? "receipt"}.png`;
      link.click();
      URL.revokeObjectURL(url);
    });
  } catch {
    toast.error("Failed to capture image");
  }
};
